<script setup>
import { ref, watch } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const isEnabled = ref(false);

const { currentAccount, updateAccount } = useAccount();

watch(
  currentAccount,
  () => {
    const { delivery_notification_enabled } =
      currentAccount.value?.settings || {};
    isEnabled.value = !!delivery_notification_enabled;
  },
  { deep: true, immediate: true }
);

const toggleDeliveryNotification = async () => {
  try {
    await updateAccount({
      delivery_notification_enabled: isEnabled.value,
    });
    useAlert(
      isEnabled.value
        ? 'Notificação de entrega ativada'
        : 'Notificação de entrega desativada'
    );
  } catch (error) {
    useAlert('Erro ao atualizar configuração de notificação');
  }
};
</script>

<template>
  <SectionLayout
    title="Notificação de Entrega ao Cliente"
    description="Quando ativado, o cliente receberá uma mensagem automática no WhatsApp quando o pedido sair para entrega, com os itens, valores e ID do pedido."
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch v-model="isEnabled" @change="toggleDeliveryNotification" />
      </div>
    </template>
  </SectionLayout>
</template>
